import { useEffect, useState } from 'react'
import { useFormikContext } from 'formik'
import { PaymentFormValues } from '@entities/payment'

export const useEmailTooltip = () => {
  const [isTooltipVisible, setIsTooltipVisible] = useState<boolean>(false)

  const { values } = useFormikContext<PaymentFormValues>()

  useEffect(() => {
    setIsTooltipVisible(values.email.length >= 3)
  }, [values.email])

  const showTooltip = () => setIsTooltipVisible(true)

  const hideTooltip = () => setIsTooltipVisible(false)

  return { isTooltipVisible, showTooltip, hideTooltip }
}
